"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var antd_1 = require("antd");
var CardRowTextEditor_1 = require("../../../../../shared/components/editors/CardRowTextEditor");
var notificationHelper_1 = require("../../../../../shared/helpers/notificationHelper");
var AdminProfileLang_1 = require("./lang/AdminProfileLang");
var webTransport_1 = require("../../../../../shared/modules/webTransport");
var webAApi_1 = require("../../../../api/webAApi");
var PDashBoard_1 = require("../../main_dashboard/ui/PDashBoard");
var PAdminProfile = /** @class */ (function (_super) {
    __extends(PAdminProfile, _super);
    function PAdminProfile(props) {
        return _super.call(this, props) || this;
    }
    PAdminProfile.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                name: data.name,
                surname: data.surname,
                skype: data.skype,
                phone: data.phone,
                email: data.email
            });
        });
        this.setState({
            name: this.props.data.DATA.name,
            surname: this.props.data.DATA.surname,
            skype: this.props.data.DATA.skype,
            phone: this.props.data.DATA.phone,
            email: this.props.data.DATA.email,
            lang: AdminProfileLang_1.AdminProfileLangFactory.getLangInstance(this.props.state.getLang())
        });
        this.props.data.LoadData();
    };
    PAdminProfile.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PAdminProfile.prototype.OnUpdateDataClick = function () {
        var _this = this;
        this.props.data.EditActiveAdminProfile({
            email: this.state.email,
            name: this.state.name,
            surname: this.state.surname,
            phone: this.state.phone,
            skype: this.state.skype
        }, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.state.lang.msg_data_updated);
        });
    };
    PAdminProfile.prototype.OnLoadDataClick = function () {
        var _this = this;
        this.props.data.LoadData(true, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.state.lang.msg_data_loaded);
        });
    };
    PAdminProfile.prototype.DoChangeAdminPassword = function (Old_Pass, new_Pass, onDone) {
        var _this = this;
        var _oldPassHash = webTransport_1.webTransport.calcPassSign(Old_Pass);
        webAApi_1.DoChangeActiveAdminPassword.exec({
            data: {
                old_pass_hash: _oldPassHash,
                new_pass: new_Pass,
            }
        }, function (resp) {
            webTransport_1.webTransport.setSign(webTransport_1.webTransport.calcSign(webTransport_1.webTransport.getLoginKey(), webTransport_1.webTransport.getLogin(), new_Pass));
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this.props.dialogApiError.ShowApiError(err);
        });
    };
    PAdminProfile.prototype.OnChangePasswordClick = function () {
        var _this = this;
        this.props.dialog.SetOnYesClick(function (oldPass, newPass) {
            _this.DoChangeAdminPassword(oldPass, newPass, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.state.lang.msg_pwd_changed);
            });
        }).Show();
    };
    PAdminProfile.prototype.getButtonsRenderObject = function () {
        var _this = this;
        var _ret = [];
        _ret.push(React.createElement(antd_1.Tooltip, { title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", key: 3 },
            React.createElement(antd_1.Icon, { type: "close-circle", theme: "outlined", style: { cursor: "pointer", fontSize: "24px", color: "#1890ff", marginLeft: "5px" }, onClick: function () {
                    _this.props.state.NavigateDocumentDescription(PDashBoard_1.default.getPageDescription(_this.props.state));
                } })));
        return _ret;
    };
    PAdminProfile.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { height: "calc( 100vh - " + this.props.state.UIHeaderHeightPx + "px )", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
            React.createElement(antd_1.Card, { title: React.createElement("div", { style: { textAlign: "center" } },
                    this.state.lang.editor_title,
                    " ",
                    this.props.state.GetUserLogin()), bordered: true, hoverable: false, style: {
                    width: "960px",
                    maxWidth: "960px",
                    minWidth: "960px",
                    height: "410px",
                    maxHeight: "410px",
                    minHeight: "410px",
                    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)"
                }, extra: React.createElement("div", { style: { display: "flex", flexDirection: "row", flexWrap: "nowrap" } }, this.getButtonsRenderObject()) },
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: this.state.lang.fc_admin_name, placeholder: this.state.lang.fp_admin_name }, value: this.state.name, onValueChanged: function (newVal) { _this.setState({ name: newVal }); } }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: this.state.lang.fc_admin_surname, placeholder: this.state.lang.fp_admin_surname }, value: this.state.surname, onValueChanged: function (newVal) { _this.setState({ surname: newVal }); } }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: this.state.lang.fc_admin_skype, placeholder: this.state.lang.fp_admin_skype }, value: this.state.skype, onValueChanged: function (newVal) { _this.setState({ skype: newVal }); } }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: this.state.lang.fc_admin_email, placeholder: this.state.lang.fp_admin_email }, value: this.state.email, onValueChanged: function (newVal) { _this.setState({ email: newVal }); } }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: this.state.lang.fc_admin_phone, placeholder: this.state.lang.fc_admin_phone }, value: this.state.phone, onValueChanged: function (newVal) { _this.setState({ phone: newVal }); } }),
                React.createElement(antd_1.Card.Grid, { style: { width: '100%', textAlign: 'center', boxShadow: "none" } },
                    React.createElement(antd_1.Button.Group, null,
                        React.createElement(antd_1.Button, { ghost: true, style: { width: "180px" }, type: "primary", onClick: this.OnLoadDataClick.bind(this) },
                            React.createElement(antd_1.Icon, { type: "reload" }),
                            "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435"),
                        React.createElement(antd_1.Button, { ghost: true, style: { width: "180px" }, type: "primary", onClick: this.OnUpdateDataClick.bind(this) },
                            React.createElement(antd_1.Icon, { type: "upload" }),
                            "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435"),
                        React.createElement(antd_1.Button, { ghost: true, style: { width: "180px" }, type: "primary", onClick: this.OnChangePasswordClick.bind(this) },
                            React.createElement(antd_1.Icon, { type: "key" }),
                            "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"))))));
    };
    PAdminProfile.getPageDescription = function (state) {
        var lang = AdminProfileLang_1.AdminProfileLangFactory.getLangInstance(state.getLang());
        return {
            icon: "users-cog",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_admin_profile + "-id",
            itemTitle: lang.document_title,
            route: routes_1.routes.page_admin_profile,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PAdminProfile;
}(React.Component));
exports.default = PAdminProfile;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/admin_profile/ui/PAdminProfile.tsx
// module id = 1853
// module chunks = 0